import React, { useState } from 'react';
import LomavisButtonToggle1 from '../../../generic/buttons/LomavisButtonToggle1';
import { useTranslate } from '@tolgee/react';
import { CONFIG_SELECT_OPTIONS } from '../../../../redux/slices/LomavisPostApproval/constants';
import { useDispatch, useSelector } from 'react-redux';
import { setLocalStates } from '../../../../redux/slices/LomavisPostApproval/lomavisPostApproval';

const ConfigurationToggle: React.FC = () => {
  const dispatch = useDispatch();
  const [selected, setSelected] = useState('config');
  const { t } = useTranslate();

  const {
    local_states: { selected_config_tab }
  } = useSelector((state: any) => state.lomavisPostApproval);

  return (
      <div className="border rounded p-1 border-secondary">
        <div className="btn-group w-100">
          <button type="button" role={'group'}
                  className="btn d-flex align-items-center fw-bold rounded btn-sm bg-light-primary text-primary gap-2">
            <i className="fa-duotone fa-solid fa-gears fs-1 text-primary"></i><span className="flex-grow-1 text-center fs-6"
                                                                      >{t('lomavisPostApproval.configuration.config')}</span></button>
        </div>
      </div>
    // <LomavisButtonToggle1
    //   buttonLeftFaIconClass=" fa-duotone fa-solid fa-rocket"
    //   buttonLeftText={t('lomavisPostApproval.configuration.config')}
    //   buttonLeftValue={CONFIG_SELECT_OPTIONS.CONFIG}
    //   buttonRightFaIconClass="fa-duotone fa-solid fa-layer-group"
    //   buttonRightText={t('lomavisPostApproval.configuration.post')}
    //   buttonRightValue={CONFIG_SELECT_OPTIONS.POST}
    //   value={selected_config_tab}
    //   onChange={(value: string) => {
    //     dispatch(setLocalStates({ key: 'selected_config_tab', value }));
    //   }}
    // />
  );
};

export default ConfigurationToggle;
